module.exports = __webpack_public_path__ + "static/media/inst.15556d91.svg";